import React from 'react';

import Box from '@mui/material/Box';
import {
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  Toolbar,
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
} from '@mui/x-data-grid';

import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';

import ToolbarExport from './ToolbarExport';
import { CustomToolbarProps } from './types';

const CustomToolbar: React.FunctionComponent<CustomToolbarProps> = ({
  showQuickFilter,
  showHeader,
  dataURL,
  columnsState,
  columnsDefinition,
  onlyBasicExport,
  disableExport,
}) =>
  showHeader ? (
    <Toolbar
      style={{
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        minHeight: '76px',
        display: 'flex',
        paddingLeft: '16px',
      }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      {!disableExport && (
        <ToolbarExport
          url={dataURL}
          columnsState={columnsState}
          columnsDefinition={columnsDefinition}
          onlyBasicExport={onlyBasicExport}
        />
      )}
      <Box sx={{ flex: 1 }} />
      {showQuickFilter && (
        <QuickFilter expanded>
          <QuickFilterControl
            render={({ ref, ...other }) => (
              <TextField
                {...other}
                sx={{ width: 260 }}
                inputRef={ref}
                aria-label="Search"
                placeholder="Search..."
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: other.value ? (
                      <InputAdornment position="end">
                        <QuickFilterClear
                          edge="end"
                          size="small"
                          aria-label="Clear search"
                          material={{ sx: { marginRight: -0.75 } }}
                        >
                          <CancelIcon fontSize="small" />
                        </QuickFilterClear>
                      </InputAdornment>
                    ) : null,
                    ...other.slotProps?.input,
                  },
                  ...other.slotProps,
                }}
              />
            )}
          />
        </QuickFilter>
      )}
    </Toolbar>
  ) : null;

export default CustomToolbar;
